<template>
  <div class="row">
    <div class="col-12 form-group" :class="format">
      <label :for="label" class="form-label">{{ clearCase(label) }}</label>
      <div :class="errors[label] ? 'bg-danger' : ''">
        <slot></slot>
      </div>
      <span
        v-if="errors[label]"
        class="text-danger"
        v-html="errors[label][0]"
      />
    </div>
  </div>
</template>
<script>
import helper from "@/assets/js/helper";
import { mapState } from "vuex";
export default {
  mixins: [helper],
  props: {
    label: { default: "" },
    format: { default: null },
  },
  computed: {
    ...mapState(["errors"]),
  },
  methods: {},
  mounted() {},
};
</script>